import { MapPin, ExternalLink } from 'lucide-react'

const TravelInfo = () => {
  const googleMapsUrl = "https://www.google.com/maps/search/?api=1&query=4816+Deshong+Dr+Plant+City+FL"

  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Venue Location
          </h2>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto">
            Join us at the Big Red Barn in beautiful Plant City, Florida
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Venue Address */}
          <div className="bg-rose-gold/10 rounded-xl p-8 mb-8">
            <h3 className="font-serif text-2xl font-bold text-charcoal mb-4 flex items-center gap-3">
              <MapPin className="w-6 h-6 text-sage" />
              Big Red Barn
            </h3>
            <p className="text-charcoal/80 text-lg mb-6">
              4816 Deshong Dr<br />
              Plant City, FL 33565
            </p>
            <a
              href={googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary inline-flex items-center"
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              Open in Google Maps
            </a>
          </div>

          {/* Embedded Google Map */}
          <div className="rounded-xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13680.66713037125!2d-82.1663231176442!3d28.073785739368216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd35886f0830c3%3A0xe5983d380974e47b!2s4816%20Deshong%20Dr%2C%20Plant%20City%2C%20FL%2033565!5e0!3m2!1sen!2sus!4v1768760513015!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
              title="Big Red Barn Location Map"
            />
          </div>
        </div>

        {/* Contact */}
        <div className="mt-12 text-center">
          <p className="text-charcoal/60">
            Need help with directions?{' '}
            <a href="mailto:doreenandedwin0418@gmail.com" className="text-sage-light hover:underline">
              Contact us
            </a>
          </p>
        </div>
      </div>
    </section>
  )
}

export default TravelInfo
